<template>
  <div id="app" :class="{popup: $root.popUpShown}">
    <Hero />
    <main>
      <router-view/>
    </main>
    <Footer />
    <Popup />
    <CartStatus />
  </div>
</template>

<script>
import Footer from './components/Footer'
import Popup from './components/Popup'
//import Nav from './components/Nav'
import Hero from './components/Hero'
import CartStatus from './components/cart/CartStatus'
export default {


  components: {
    Hero,
    Footer,
    Popup,
    /*Nav,*/
    CartStatus
  }

}
</script>
<style lang="scss">

  @import "@/styles/style.scss";

  .fade-enter-active,
  .fade-leave-active {
    transition-duration: 0.5s;
    transition-timing-function: cubic-bezier(0.19, 1, 0.22, 1);
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0;
    transform: translateY(20px);
  }

  .cartBtn {
    position: fixed;
  }


  #app.popup {
    overflow: hidden;
  }




</style>